<template>
  <div class="price">
    <el-image :src="img" class="goodImg" fit="contain">
      <template slot="error">
        <img
          src="~@/assets/img/bitmap.png"
          style="object-fit: contain"
          class="goodsImg"
        />
      </template>
    </el-image>
  </div>
</template>

<script>
export default {
  props: ['img']
}
</script>

<style>
.goodImg {
  width: 400px;
  height: 400px;
  object-fit: contain;
}
</style>
